module.exports = __webpack_public_path__ + "static/media/icon-stats.4589d925.svg";